import React from "react";

const RedCircle = ({ width, height, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="8.5"
        fill="white"
        stroke="#FF6C6C"
        stroke-width="3"
      />
    </svg>
  );
};

export default RedCircle;
